<div class="p-4 queue-table">

  <app-queue-action-buttons
    (resetData)="reloadQueue()"
    (clear)="clearAll()">
  </app-queue-action-buttons>

  <p-table
    #dt
    styleClass="has-border frozen-columns-table"
    stateStorage="session"
    [stateKey]="filterStoreName"
    aria-label="Appeals and Grievances queue table"
    [(selection)]="selectedQueues"
    [rows]="amountOfRows"
    [columns]="cols"
    [value]="pageResults"
    [paginator]="true"
    [alwaysShowPaginator]="false"
    [totalRecords]="totalRecords"
    [lazy]="true"
    [loading]="isLoading"
    [scrollable]="true"
    scrollHeight="flex"
    (selectionChange)="onSelectionChange()"
    (onLazyLoad)="loadData($event)"
    dataKey="appealAndGrievanceQueueId"
    [filterDelay]="1000"
    resetTablePageOnSort
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="min-width: 42px;" alignFrozen="left" pFrozenColumn [frozen]="true" [class]="{'frozen-border': true}">
          <p-checkbox (click)="selectAllCheckbox()" [(ngModel)]="topCheckboxValue" [binary]="true"></p-checkbox>
        </th>
        @for (col of columns; track col) {
          @if (!notFilteredFields.includes(col.field)) {
            <th
              alignFrozen="left"
              pFrozenColumn
              [frozen]="col.field === 'alertStatus'||col.field === 'subscriberName' || col.field === 'authorizationNumber'"
              [class]="{'frozen-border': col.field === 'subscriberName' || col.field === 'authorizationNumber'}"
              [pSortableColumn]="col.field !== 'alertStatus' ? col.field : null"
              [ngStyle]="{ display: col.display, minWidth: col.width }"
            >
              {{ col.header }}
              <p-sortIcon
                *ngIf="col.field !== 'alertStatus'"
                [field]="col.field"
                ariaLabel="Activate to sort"
                ariaLabelDesc="Activate to sort in descending order"
                ariaLabelAsc="Activate to sort in ascending order"
              >
              </p-sortIcon>
            </th>
          }
          @if (notFilteredFields.includes(col.field)) {
            <th [ngStyle]="{ minWidth: col.width }">{{ col.header }}</th>
          }
        }
      </tr>
      <tr class="header-filter">
        <th alignFrozen="left" pFrozenColumn [frozen]="true" [class]="{'frozen-border': true}"></th>
        <th alignFrozen="left" pFrozenColumn [frozen]="true" [class]="{'frozen-border': true}"></th>
        <th alignFrozen="left" pFrozenColumn [frozen]="true" [class]="{'frozen-border': true}">
          <input
            class="p-column-filter"
            pInputText
            type="text"
            placeholder="Search"
            [value]="dt.filters['subscriberName,subscriberNumber']?.value"
            (input)="filterTable($event.target.value.trim(), ['subscriberName', 'subscriberNumber'], 'contains')"
          />
        </th>
        <th alignFrozen="left" pFrozenColumn [frozen]="true" [class]="{'frozen-border': true}">
          <input
            class="p-column-filter"
            pInputText
            type="text"
            placeholder="Search"
            [value]="dt.filters.authorizationNumber?.value"
            (input)="filterTable($event.target.value.trim(), 'authorizationNumber', 'contains')"
          />
        </th>
        <th>
          <input
            class="p-column-filter"
            pInputText
            type="text"
            placeholder="Search"
            [value]="dt.filters.referenceNumber?.value"
            (input)="filterTable($event.target.value.trim(), 'referenceNumber', 'contains')"
          />
        </th>
        <th>
          <p-date-picker
            appendTo="body"
            styleClass="p-column-filter"
            dateFormat="mm/dd/y"
            selectionMode="range"
            [(ngModel)]="receivedOnRange"
            [showIcon]="true"
            (onSelect)="filterTable(receivedOnRange, 'receivedOn', 'dateRange')"
            [showButtonBar]="true"
            (onClearClick)="filterTable(null, 'receivedOn', 'dateRange')"
          ></p-date-picker>
        </th>
        <th>
          <p-multiSelect
            styleClass="p-column-filter"
            placeholder="Filter"
            appendTo="body"
            [ngModel]="dt.filters.tenantName?.value"
            [options]="tenantList"
            [maxSelectedLabels]="0"
            [filter]="false"
            (onChange)="filterTable($event.value, 'tenantName', 'in')"
          ></p-multiSelect>
        </th>
        <th>
          <p-multiSelect
            styleClass="p-column-filter"
            appendTo="body"
            placeholder="Filter"
            [ngModel]="dt.filters.lineOfBusinessId?.value"
            [options]="lineOfBusinessList"
            [maxSelectedLabels]="0"
            [filter]="false"
            (onChange)="filterTable($event.value, 'lineOfBusinessId', 'in')"
          ></p-multiSelect>
        </th>
        <th>
          <p-multiSelect
            styleClass="p-column-filter"
            appendTo="body"
            placeholder="Filter"
            [ngModel]="dt.filters.productId?.value"
            [options]="productsList"
            [maxSelectedLabels]="0"
            [filter]="false"
            (onChange)="filterTable($event.value, 'productId', 'in')"
          ></p-multiSelect>
        </th>
        <th>
          <p-multiSelect
            styleClass="p-column-filter"
            appendTo="body"
            placeholder="Filter"
            [ngModel]="dt.filters.urgency?.value"
            [options]="urgencyList"
            [maxSelectedLabels]="0"
            [filter]="false"
            (onChange)="filterTable($event.value, 'urgency', 'in')"
          ></p-multiSelect>
        </th>
        <th>
          <p-multiSelect
            styleClass="p-column-filter"
            placeholder="Filter"
            appendTo="body"
            filterBy="label,value.name"
            [options]="serviceProviderList"
            [maxSelectedLabels]="0"
            [filter]="true"
            [(ngModel)]="serviceProviderValue"
            multiselectOnSelectAll
            (onChange)="filterServiceProvider($event)"
          >
            <ng-template let-pItem pTemplate="item">
              <span [title]="pItem?.value?.name">{{ pItem.label }}</span>
            </ng-template>
          </p-multiSelect>
        </th>
        <th>
          <p-multiSelect
            styleClass="p-column-filter"
            placeholder="Filter"
            appendTo="body"
            [ngModel]="dt.filters.subscriberState?.value"
            [options]="stateList"
            [maxSelectedLabels]="0"
            multiselectOnSelectAll
            (onChange)="filterTable($event.value, 'subscriberState', 'in')"
          ></p-multiSelect>
        </th>
        <th></th>
        <th>
          <p-multiSelect
            styleClass="p-column-filter"
            placeholder="Filter"
            appendTo="body"
            [ngModel]="dt.filters.status?.value"
            [options]="agStatusList"
            [maxSelectedLabels]="0"
            [filter]="false"
            multiselectOnSelectAll
            (onChange)="filterTable($event.value, 'status', 'in')"
          ></p-multiSelect>
        </th>
        <th>
          <p-date-picker
            appendTo="body"
            styleClass="p-column-filter"
            dateFormat="mm/dd/y"
            selectionMode="range"
            [(ngModel)]="dueDateTimeRange"
            [showIcon]="true"
            (onSelect)="filterTable(dueDateTimeRange, 'dueDateTime', 'dateRangeWihoutOffset')"
            [showButtonBar]="true"
            (onClearClick)="filterTable(null, 'dueDateTime', 'dateRangeWihoutOffset')"
          ></p-date-picker>
        </th>
        <th>
          <p-multiSelect
            styleClass="p-column-filter"
            placeholder="Filter"
            appendTo="body"
            [ngModel]="dt.filters.assignedToName?.value"
            [options]="assignedToNameList"
            [maxSelectedLabels]="0"
            [filter]="false"
            multiselectOnSelectAll
            (onChange)="filterTable($event.value, 'assignedToName', 'in')"
          ></p-multiSelect>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          No records found
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-queue let-columns="columns">
      <tr [pSelectableRow]="queue">
        <td alignFrozen="left" pFrozenColumn [frozen]="true" [class]="{'frozen-border': true}">
          <p-tableCheckbox [value]="queue" [disabled]="userName !== queue.assignedToName"></p-tableCheckbox>
        </td>
        @for (col of columns; track col) {
          <td
            [ngStyle]="{ display: col.display }"
            alignFrozen="left"
            pFrozenColumn
            [frozen]="col.field === 'alertStatus'|| col.field === 'subscriberName' || col.field === 'authorizationNumber'"
            [class]="{'frozen-border': col.field === 'alertStatus'|| col.field === 'subscriberName' || col.field === 'authorizationNumber'}"
          >
            @switch (col.field) {
              @case ('alertStatus') {
                <span class="alert-status-label flex items-center gap-1"
                      [class]="{'escalated-case': queue.isEscalatedCase,
           'overdue-case': queue.dueDateTime && queue.dueDateDaysHours < 0}">
              @if (queue.isEscalatedCase) {

                <i class="pi pi-info-circle alert-escalated-icon"></i>
                <span>Escalated Case</span>

              } @else {

                @if (queue.dueDateTime && queue.dueDateDaysHours < 0) {

                  <i class="pi pi-clock alert-icon"></i>
                  <span class="overdue-case">Time Overdue</span>

                }

              }

            </span>

              }
              @case ('subscriberName') {

                <div class="flex">
              <span pTooltip="{{ queue.subscriberName }} | {{ queue.subscriberNumber }}" tooltipPosition="bottom"
                    tooltipStyleClass="tooltip-xxl-size">
                <button
                  pButton
                  class="p-button-link text-truncate px-0 member-link block"
                  [label]="queue.subscriberName || queue.subscriberNumber"
                  [ngStyle]="{'max-width': queue.isEscalatedCase ? '7rem' : '9rem'}"
                  (click)="displayMemberPage($event, queue)"
                ></button>
                      </span>
                  <!-- TODO p-block make changes in UI lib to fix it globally -->
                  @if (queue.isEscalatedCase) {
                    <span pTooltip="Escalated Case" tooltipPosition="bottom"></span>
                  }
                </div>
              }
              @case ('authorizationNumber') {
                @if (queue.authorizationNumber) {
                  <button
                    pButton
                    class="p-button-link text-truncate px-0"
                    [label]="queue.authorizationNumber"
                    (click)="displayAuthPage($event, queue)"
                  ></button>
                }
              }
              @case ('referenceNumber') {
                <span pTooltip="{{ queue.referenceNumber }}" tooltipPosition="bottom"
                      tooltipStyleClass="tooltip-xl-size">
                      <button
                        pButton
                        class="p-button-link text-truncate px-0 block p-text-align-left"
                        [label]="queue.referenceNumber"
                        (click)="displayAppealsAndGrievanceDetail($event, queue)"
                      ></button>
                    </span>
              }
              @case ('receivedOn') {
                {{ queue.receivedOn | date: 'MM/dd/yyyy hh:mm:ss a' }}
              }
              @case ('tenantName') {
                {{ queue.tenantName }}
              }
              @case ('lineOfBusinessName') {
                {{ queue.lineOfBusinessName }}
              }
              @case ('productName') {
                {{ queue.productName }}
              }
              @case ('urgency') {
                {{ queue.urgency }}
              }
              @case ('serviceProviderName') {
                <span
                  pTooltip="{{ queue.serviceProviderName + '\n' + queue.serviceProviderNPI }}"
                  tooltipPosition="bottom"
                  tooltipStyleClass="tooltip-xxl-size">
                      {{ queue.serviceProviderName }}
                    </span>
              }
              @case ('subscriberState') {
                {{ queue.subscriberState }}
              }
              @case ('status') {
                <span
                  pTooltip="{{ 'A&G Status: ' + queue.status + '\n' + 'Status Reason: ' + (queue.statusReason | getStatusComment: queue.statusComment | emptyPlaceholder) }}"
                  tooltipPosition="bottom"
                  tooltipStyleClass="tooltip-xxl-size"
                  class="truncate">
                      {{ queue.status }}
                    </span>
              }
              @case ('dueDateTime') {
                <!-- Dates in the past should be also supported, to understand how much time ago due date has expired -->
                <span pTooltip="{{ currentDate | timeSpent: '[d] days [h] hours [m] minutes' : queue.dueDateTime }}"
                      tooltipPosition="bottom" tooltipStyleClass="tooltip-xl-size">
                      {{ queue.dueDateTime | date: 'MM/dd/yyyy hh:mm:ss a' }}
                    </span>
                @if (queue.dueDateTime && queue.dueDateDaysHours < 0) {
                  <span tooltipPosition="bottom"></span>
                }
              }
              @case ('assignedToName') {
                <span
                  style="max-width: 11rem"
                  pTooltip="{{ queue.assignedToName }}"
                  tooltipPosition="bottom"
                  tooltipStyleClass="tooltip-xl-size"
                >
                      <ng-container>
                        <button
                          pButton
                          class="truncate assign-button block"
                          [label]="queue.assignedToName ? queue.assignedToName : 'Assign to me'"
                          (click)="assignHandler(queue)"
                        >
                          @if (!queue.assignedToName) {
                            <span
                              class="pi p-button-icon p-button-icon-left pi-user-plus"
                            ></span>
                          } @else {
                            <span
                              class="pi p-button-icon p-button-icon-left pi-times"
                            ></span>
                          }
                        </button>
                      </ng-container>
                    </span>
              }
              @default {
                <div
                  [innerText]="queue[col.field] || ''"
                  class="truncate"
                ></div>
              }
            }
          </td>
        }
      </tr>
    </ng-template>
  </p-table>

  @if (pageResults.length && selectedQueues.length !== 0) {
    <div class="py-4 buttons-queue">
      <div class="mb-2">
        <strong>{{ selectedMessage }}</strong>
      </div>
      <div class="mb-2">
        <button
          pButton
          label="Remove from Queue"
          class="p-button mr-2"
          (click)="removeFromQueueConfirmation()"
        ></button>
      </div>
    </div>
  }
</div>

<p-confirmDialog
  #cd
  header="Info"
  rejectButtonStyleClass="p-button-info"
  appendTo="body"
>
</p-confirmDialog>
